import Http from '@/services/http';
import {
  ComparativeAnalysisChart,
  ComparativeAnalysisPagedRequest,
  ComparativeAnalysisPagedResponse,
  ComparativeAnalysisDuvalRequest,
} from 'sigma-mappings';
import msis127ErrorHandler from '@/domain/data/installation/engineering/cromaMSIS127ErrorHandler';

const urls = {
  comparativeAnalysis: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras/analise-comparativa`,
  duvalGraphs: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras/analise-comparativa/duval/grafico`,
};

/* istanbul ignore next */
const error = {
  ...msis127ErrorHandler,
};

const getComparativeAnalysis = (assetModuleId, payload) => {
  const mappedPayload = new ComparativeAnalysisPagedRequest(payload);
  return new Http(error)
    .post(urls.comparativeAnalysis(assetModuleId), mappedPayload)
    .then(({ data }) => new ComparativeAnalysisPagedResponse(data))
    .catch(error.msis127ErrorHandler);
};

const getDuvalGraphs = (assetModuleId, payload) => {
  const http = new Http(error);
  const mappedPayload = new ComparativeAnalysisDuvalRequest(payload);
  return http
    .post(urls.duvalGraphs(assetModuleId), mappedPayload)
    .then(({ data }) => new ComparativeAnalysisChart(data))
    .catch(error.msis127ErrorHandler);
};

const reduceMethodstoTableObject = (methodAccumulator, method) => ({
  ...methodAccumulator,
  [method.method]: {
    alarmed: method.alarmed,
    executed: method.executed,
    diagnostics: method.diagnostics,
  },
});

const reduceNormsToTableObject = (normAccumulator, currentNorm) => {
  if (currentNorm.methods) {
    return {
      ...normAccumulator,
      ...currentNorm.methods.reduce(reduceMethodstoTableObject, {}),
    };
  }
  return normAccumulator;
};

const transformResponseToTableArray = responseData => responseData.map(
  data => ({
    sampleNumber: data.sampleNumber,
    alarmed: data.alarmed,
    ...data.norms.reduce(reduceNormsToTableObject, {}),
  }),
);

export default {
  getComparativeAnalysis,
  transformResponseToTableArray,
  getDuvalGraphs,
};
